// assets/variant-gallery-filter.js
(function () {
  function getSelectedColor() {
    // Prende SEMPRE e solo il radio attualmente selezionato
    var input = document.querySelector(
      'variant-selects input[type="radio"][name^="Colore"]:checked'
    );
    return input ? input.value.trim() : null;
  }

  function isMediaForColor(imgAlt, color) {
    if (!imgAlt || !color) return true; // se non c'è alt, non filtriamo
    // Se non contiene #COLORE_ la consideriamo generica (sempre visibile)
    if (imgAlt.indexOf('#COLORE_') === -1) return true;

    return imgAlt.toUpperCase().indexOf(color.toUpperCase()) !== -1;
  }

  function updateThumbnails(color) {
    var thumbs = document.querySelectorAll(
      'slider-component[id^="GalleryThumbnails"] .thumbnail-list__item'
    );
    thumbs.forEach(function (li) {
      var img = li.querySelector('img');
      if (!img) return;
      li.style.display = isMediaForColor(img.alt, color) ? '' : 'none';
    });
  }

  function updateMainGallery(color) {
    // Adatta ai selettori del tuo tema (Dawn/derivati)
    var slides = document.querySelectorAll(
      'slider-component[id^="GalleryViewer"] .product__media-item, ' +
      'slider-component[id^="GalleryViewer"] li[id^="Slide-"]'
    );

    slides.forEach(function (li) {
      var img = li.querySelector('img');
      if (!img) return;
      li.style.display = isMediaForColor(img.alt, color) ? '' : 'none';
    });
  }

  function updateGalleryForSelectedColor() {
    var color = getSelectedColor();
    if (!color) return;
    updateThumbnails(color);
    updateMainGallery(color);
  }

  // Primo filtraggio all'apertura
  document.addEventListener('DOMContentLoaded', function () {
    updateGalleryForSelectedColor();
  });

  // Ascolta i cambi di variante (event delegation, così funziona anche se Shopify
  // rimpiazza il blocco varianti via JS)
  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'variant-selects input[type="radio"][name^="Colore"]'
      )
    ) {
      updateGalleryForSelectedColor();
    }
  });
})();